import type { Location } from '../hooks/useHereLocation'

export const screenToLocation = (
  map: H.Map,
  evt: H.mapevents.Event,
): Location | undefined => {
  const { viewportX, viewportY } = evt.currentPointer
  const point = map.screenToGeo(viewportX, viewportY)
  if (!point) return undefined
  return { latitude: point.lat, longitude: point.lng }
}
